export default {
    add_stage: "Добавить этап",
    additional: "Дополнительный",
    alternative: "Альтернативный",
    amount_completed: "Сумма выполненная",
    apply_plan_treatment: "Применить план лечения",
    apply_to_which_teeth: "К каким зубам применить",
    apply_treatment_stage_template: "Применить шаблон этапа лечения",
    are_you_sure_you_want_to_cancel_plan: "Вы уверены, что хотите отменить план лечения?",
    by_stages: "По этапам",
    calls_planning: "Планирование звонков",
    cancel_plan_treatment: "Отменить план лечения",
    changes_in_current_stage_were_not_saved: "Изменения в текущем этапе не сохранены",
    choose_criterias_for_fill: "Выберите необходимые критерии для заполнения",
    collapse: "Свернуть",
    comments: "Комментарии",
    completed_sum: "Выполненная сумма",
    complex_doctor: "Врач комплекса",
    'DD.MM.YYYY': "ДД.ММ.ГГГГ",
    deadline2: "Крайний срок",
    delete_stage: "Удалить этап",
    document_header: "Шапка в плане лечения",
    editing_is_blocked_now_user_is_working: "Редактирование временно недоступно: сейчас работает {user}",
    expand: "Развернуть",
    grouped: "Сгруппированный",
    grouped_by_services: "Сгруппированный по услугам",
    grouped_by_teeth: "Сгруппированный по зубам",
    hide_tooth_formula: "Скрыть зубную формулу",
    kits_and_materials: "Комплекты и материалы",
    last_update: "Последнее изменение",
    left: "Осталось",
    level_description: "Описание этапа",
    main_complaints: "Основные жалобы",
    not_signed: "Не подписан",
    notification_date: "Дата уведомления",
    plan: "План",
    plan_status: "Статус плана",
    plan_treatment_application: "Применение плана лечения",
    plan_treatment_status: "Статус плана лечения",
    plan_type: "Тип плана",
    planned_sum: "Запланированная сумма",
    previous_visits: "Прошлые визиты",
    quantity: "Количество",
    recommended: "Рекомендованный",
    reset_all: "Сбросить все",
    route_list: "Маршрутный лист",
    save_as_plan_stage_template: "Сохранить как шаблон этапа лечения",
    select_a_doctor_2: "Выберите врача",
    select_all: "Отметить все",
    select_field: "Выберите направление",
    select_number: "Выберите номер",
    select_plan: "Выберите план",
    select_type: "Выберите тип",
    services_selected: "Услуг выбрано",
    show_tooth_formula: "Показать зубную формулу",
    sign_without_upload: "Подписать без загрузки",
    signed_at: "Подписан",
    stage_deletion_confirm_text: "Этап будет удалён без возможности восстановления. Все несохранённые изменения будут потеряны.",
    stage_doctor: "Врач этапа",
    stage_title: "Название этапа",
    stages_discount: "Скидка в этапах",
    total_sum: "Итого сумма",
    treatment_plan_amount: "Сумма плана лечения",
    treatment_plan_doctor: "Врач плана лечения",
    treatment_template_application: "Применение шаблона лечения",
    which_fields_to_fill: "Какие поля заполнить",
    write_patient_complaints: "Напишите жалобы пациента",
    write_stage_description: "Напишите описание этапа"
}
